module.exports = __webpack_public_path__ + "img/user_job.3c584519.png";